import React, { useState } from 'react';
import Icon from '../../components/Icon/Icon';
import NewsTable from '../../components/NewsTable/NewsTable';
import './Admin.scss';

function NewsDashboard() {
    const [totalCount, setTotalCount] = useState(0);

    return (
        <div className="container-main">
            <div className="content-header">
                <div className="header-left">
                    <Icon alias="news" width={24} height={24} color="#1a1a1a" />
                    <h2>News [{totalCount.toLocaleString()}]</h2>
                </div>
                <p className="header-subtitle">Manage news, engagement and contributions</p>
            </div>
            <NewsTable onTotalCountChange={setTotalCount} />
        </div>
    );
}

export default NewsDashboard;
